<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          :key="index.menuPath"
          :item="index"
          :base-path="index.menuPath"
        />
        <sidebar-item
          v-for="route in menuList"
          :key="route.id"
          :item="route"
          :base-path="route.menuPath || ''"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      index: {
        menuPath: "/",
        menuName: "首页",
        menuIcon: "dashboard",
        id: "index",
        status: 1,
      },
      menuList: [],
    };
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      if (meta.id) {
        return meta.id;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  created() {
    this.menuList = JSON.parse(sessionStorage.getItem("menuList") || "[]");
    this.menuList = this.filterMenuList(this.menuList);
  },
  methods: {
    filterMenuList(list) {
      let menuList = list.filter((item) => {
        if (item.childs && item.childs.length > 0) {
          this.filterMenuList(item.childs);
          return item;
        } else {
          if (item.menuPath) {
            return item;
          }
        }
      });
      return menuList;
    },
  },
};
</script>
